/**
 * returnColor converts color object into string that can be used with different CSS properties like background. Intended to work with RGBA color objects
 * @param c {Object} contains properties with numbers representing a RGBA color
 * @returns color {String} string representation of the colors as used by the CSS background property
 */
export var returnColor = function (c) { return "rgba(" + (c.r || 0) + ", " + (c.g || 0) + ", " + (c.b || 0) + ", " + (c.a || 1) + ")"; };
//# sourceMappingURL=ReturnColor.js.map